import { Injectable } from '@angular/core';

import { createDialogServiceBase } from 'tiime-material';

import { ReturnedUpdateContractStatusDialogData } from './returned-update-contract-status-dialog-data';
import { UpdateContractStatusDialogData } from './update-contract-status-dialog-data';
import { UpdateContractStatusDialogComponent } from './update-contract-status-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UpdateContractStatusDialogService extends createDialogServiceBase<
  ReturnedUpdateContractStatusDialogData,
  UpdateContractStatusDialogData
>(UpdateContractStatusDialogComponent) {}
